import { rand, randOf } from "../../../../common/helpers/generators";

const Rates = {
    flat: 75,
    leaf: 25,
    shadow: 30,
};

function buttons() {
    if (_rate("flat")) {
        return flat();
    } else {
        return leaf();
    }
}

// 75%
function flat() {
    return {
        ..._every(),

        type: "flat",

        radius: rand(0, 25),
    };
}

// 25%
function leaf() {
    return {
        ..._every(),

        type: "leaf",

        radius: rand(25, 100),
        from: randOf(["top-left", "top-right"]),
    };
}

/* function bevel() {
    return {
        ..._every(),

        type: "bevel",

        offset: rand(10, 20),
        from: randOf(["top-left", "top-right"]),
    };
} */

function _every() {
    return {
        width: rand(1, 4),
        shadow: _rate("shadow"), // 30%
    };
}

function _rate(name) {
    return rand(0, 100) < Rates[name];
}

export default buttons;
export { flat, leaf };
